import {Enum} from './enun';

export const notificationStatus = new Enum({
  none: -1,
  error: 0,
  success: 1,
  checking: 2,
  extracting: 3,
  validating: 4,
  transformation: 5,
  complete: 6,
  processing: 7,
  confirm: 8,
  approve: 9,
  sending: 10,
  sent: 11,
});

export const notificationColors = new Enum({
  grey: -1,
  red: 0,
  green: 1,
  yellow: 2,
  olive: 3,
  orange: 4,
  violet: 5,
  blue: 6,
  teal: 7,
  purple: 8,
  pink: 9,
  brown: 10,
  black: 11
});

export const notificationContext = new Enum({
  uploading: 1,
  checking: 2,
  extracting: 3,
  validating: 4,
  transformation: 5,
  complete: 6,
  processing: 7,
  confirm: 8,
  approve: 9,
  sending: 10,
  sent: 11,
});

export const notificationType = new Enum({
  success: 1,
  alert: 2,
  error: 3
});
